%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: 85449c2ea301fc54091646f096d9e4dc, type: 3}
  m_Name: GolemHuddle
  m_EditorClassIdentifier: 
  impactPrefab: {fileID: 0}
  handGlowPrefab: {fileID: 0}
  handGlowScale: 0.2
  castAuraPrefab: {fileID: 0}
  castAuraScale: 0.4
  castAuraYOffset: 0.5
  attachCastAuraToCaster: 0
  playOnCast: []
  castSound: {fileID: 0}
  castSoundVolume: 0.2
  soundBeforeChannel: {fileID: 8300000, guid: 24e9caa2bd7c3294cbfc8b7517f0627b, type: 3}
  beforeChannelSoundDelay: 0
  soundAfterChannel: {fileID: 0}
  afterChannelSoundDelay: 0
  animation: 0
  animationVariation: 439
  castDelay: 0
  animationSpeed: 1
  animationDuration: 20
  skipCooldownOnChannel: 0
  spellName: Huddle
  description: Huddle down. Spawn ice orbs around the room.
  icon: {fileID: 2800000, guid: 6c1544aa9d7d1104e9ce1d474b131ef7, type: 3}
  usableBy: 15000000
  cooldown: 55
  castTime: 0
  isCastInterruptible: 1
  channelTime: 20
  isOnGlobalCooldown: 1
  aoeRadius: 0
  isHidden: 0
  isInternal: 0
  isRegional: 0
  preventManualCasts: 1
  useKeyboardForFacing: 0
  spellType: {fileID: 11400000, guid: 80cddad32b4f07e4bbf640afdccb32f4, type: 2}
  spellKey: 100079
  alwaysCastableSpell: 0
  luaScript: {fileID: 4900000, guid: e09a21d2e9553c2458020bc29f7845db, type: 3}
